@import '../../global/accessibility.css';
@import 'src/global/variables';

:host {
	position: relative;
}

.nj-passanger {
    position: relative;
}

.nj-passanger-field {
	position: relative;

	display: inline-block;
	width: 100%;

	input {
		@include nj-input;
        @include nj-input-select;

		width: 100%;
        padding-right: 125px;
        text-overflow: ellipsis;

        background: none;
	}

	label {
		@include nj-label;
		@include nj-label--active;
	}

    button {
        position: absolute;
        top: 50%;
        right: 1rem;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        background: none;
        border: none;
        cursor: pointer;
        transform: translateY(-50%);

        > span {
            color: $tint-oebb;;
            margin-right: 0.5em;
        }

    }

    &--invalid {
        input, label, .validation-text {
            color: $tint-oebb;
        }

        input {
            border-color: currentColor;
        }
    }
}
